import React from 'react'

const MetadataConformityCheckSmartFunctionDetailsPage = () => {
  return <div>MetadataConformityCheckSmartFunctionDetailsPage</div>
}

export default MetadataConformityCheckSmartFunctionDetailsPage
